/* eslint-disable arrow-parens */
import React from 'react'
import { useSelector } from 'react-redux'
import { getFirstName } from '../../../../helpers/users'

// store
import { getUserObject } from '../../../../store/selectors/userProfile'

// constants
import MenuItems from '../../../../constants/menuItems'

// components
import MenuItem from './components/menuItem'
import WelcomeBanner from './components/welcomeBanner'
import LoadingSpinner from '../../../../components/loadingSpinner'
import { useIsMobileView } from '../../../../utils/isMobileView'

function Dashboard() {
  const userData = useSelector(getUserObject)
  const menu = MenuItems()
  const isMobileView = useIsMobileView()

  if (getFirstName(userData) === '') {
    return <LoadingSpinner />
  }

  return (
    <div
      style={{
        backgroundColor: '#E8E6E3',
        minHeight: '100vh',
        width: '100vw',
      }}
    >
      <WelcomeBanner />
      <div
        style={{
          backgroundColor: '#E8E6E3',
          width: isMobileView ? '100%' : '90%',
          paddingLeft: '0',
          paddingRight: '0',
          paddingTop: '15px',
          marginTop: '23px',
          paddingBottom: '100px',
          marginLeft: isMobileView ? '0' : '130px',
          display: 'flex',
          justifyContent: isMobileView ? 'center' : 'left',
          alignItems: isMobileView ? 'center' : 'stretch',
          overflow: 'hidden',
          flexWrap: 'wrap',
        }}
      >
        {menu.map((menuItem) => (
          <MenuItem menuItem={menuItem} key={menuItem.id} />
        ))}
      </div>
    </div>
  )
}

export default Dashboard
